import { render, staticRenderFns } from "./LogboekBase.vue?vue&type=template&id=70325f7a&scoped=true&"
import script from "./LogboekBase.vue?vue&type=script&lang=js&"
export * from "./LogboekBase.vue?vue&type=script&lang=js&"
import style0 from "./LogboekBase.vue?vue&type=style&index=0&id=70325f7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70325f7a",
  null
  
)

export default component.exports